export type MediaTypeEntity = 'song' | 'video'

export type SortByEntity = 'times_played' | 'unique_listeners'

export type SortOrderEntity = 'asc' | 'desc'

export class ComparedValueEntity {
  current!: number
  previous!: number
  diff!: number
}

export class MediaItemEntity {
  title!: string
  icon_url!: string | null
  times_played!: ComparedValueEntity
  unique_listeners!: ComparedValueEntity
}

export class MediaPageEntity {
  total!: number
  media_type!: MediaTypeEntity
  items!: MediaItemEntity[]
}

export class MediaPeriodEntity {
  date!: string
  times_played!: number
  unique_listeners!: number
}

export class MediaTotalsEntity {
  media_type!: MediaTypeEntity
  times_played!: ComparedValueEntity
  unique_listeners!: ComparedValueEntity
  periods!: MediaPeriodEntity[]
}
